<script>
	export default {
		name: 'FunctionExecuter',
		methods: {
			callFunction(name, type, params) {
				const self_ = this;

				const data_ = { type: type, params: params }

				return self_.$_fcExec_call(name, data_)
			},
			$_fcExec_call(name, data) {
				const self_ = this;
				// for debug information
				const app_ = self_.getState('app');
				app_.firebase.functions.call++;
				// call function
				const function_ = self_.firebase.app().functions()
				if(self_.env.dev) {
/* dev */			self_.logDev('Function Calling', 'Use function emulator.', { name:name, data: data })

					function_.useFunctionsEmulator("http://localhost:5000")
				}
				const call_ = function_.httpsCallable(name)

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return call_(data)
					}).then(result => {
						resolve(result.data)
					}).catch(error => {
						reject(error)
					})
				})
			}
		}
	}
</script>
